import * as styles from "./page-manager.module.scss";

export const isParentClass = styles.isParent;
export const childrenShowingClass = styles.childrenShowing;

export const toggleButtonClass = styles.childToggle;
/**
 * Gets the class to use for a level in the tree.
 *
 * @param level The level to get the class for,
 * @returns The class to use.
 */
export function getLevelClass(level: number): string {
	return `level-${level}`;
}

/**
 * Gets the selector for a lvel in the tree.
 *
 * @param level The level to get the selector for.
 * @returns The selector
 */
export function getLevelSelector(level: number): string {
	return "." + getLevelClass(level);
}
